/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Pump_Confirm_Off_SubmitInputs */

const vi_irrigation_pump_confirm_off_submit = /** @type {(inputs: Irrigation_Pump_Confirm_Off_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tắt bơm`)
};

/**

* @param {Irrigation_Pump_Confirm_Off_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_pump_confirm_off_submit = /** @type {((inputs?: Irrigation_Pump_Confirm_Off_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Pump_Confirm_Off_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_pump_confirm_off_submit(inputs)
});